import SnowflakeOverview from '@/modules/integrations/types/snowflake/SnowflakeOverview'
import SnowflakeSettings from '@/modules/integrations/types/snowflake/SnowflakeSettings'

export default Object.freeze({
  type: 'snowflake',
  title: 'Integrations_Snowflake',
  category: 'Integrations_Snowflake_Category',
  description: 'Integrations_Snowflake_Description',
  image: require('@/img/integrations/snowflake.png'),
  requiresAdmin: false,
  components: {
    overview: SnowflakeOverview,
    settings: SnowflakeSettings
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/snowflake-integration'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/snowflake/index.js